<template>
  <div class="bg-gradient-to-r from-gray-100 via-gray-300 to-white pb-4 pt-4">
    <div
      class="text-center sm:flex sm:gap-x-2 mx-auto justify-center align-center items-center"
    >
      <p
        class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl"
      >
        News
      </p>

      <div class="-mt-2 ">
        <button
          @click="redirectNews()"
          type="button"
          class="inline-flex uppercase items-center px-3.5 py-1.5 border-solid border-2 border-indigo-900 text-base font-medium rounded-md shadow-xl text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none"
        >
          <i class="text-white fas fa-search mr-1"></i> View More
        </button>
      </div>
    </div>

    <div class="mx-auto max-w-md px-4 sm:max-w-lg sm:px-6 lg:max-w-7xl">
      <div
        class="sm:grid relative mt-4 mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-5 lg:grid-cols-3"
      >
        <div
          v-for="post in filterPosts.slice(0, 3)"
          :key="post.id"
          class="flex flex-col shadow-lg overflow-hidden"
        >
          <div class="flex-1 bg-white p-3 flex flex-col justify-between">
            <div class="flex-1">
              <a @click="redirect(post)" class="cursor-pointer block">
                <p class="text-2xl font-semibold text-blue-800 uppercase">
                  <span class="text-base text-gray-400">
                    {{ dateFormat(post.created_at) }} </span
                  ><br />
                  {{ post.title }}
                  <span class="font-semibold uppercase text-sm text-indigo-700">
                    Category: {{ post.category.name }}
                  </span>
                </p>
                <p class="mt-3 text-base text-gray-600">
                  {{ post.description }}
                </p>
              </a>
            </div>

            <div class="mt-4">
              <button
                @click="redirect(post)"
                type="button"
                class="uppercase inline-flex items-center px-6 py-2 border border-indigo-600 text-sm leading-4 font-medium shadow-sm text-indigo-600 hover:text-gray-50 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Read More
              </button>

              <div class="float-right flex align-center text-gray-600">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                  /></svg
                >Share with
                <a
                  class="ml-1 cursor-pointer text-gray-400 hover:text-gray-500"
                >
                  <ShareNetwork
                    network="facebook"
                    :url="'https://www.homesby360.com/news/' + post.slug"
                    :title="post.title"
                    :description="post.description"
                    :quote="post.title"
                  >
                    <img
                      class="w-7 h-7 rounded-full"
                      src="https://img.icons8.com/fluency/48/000000/facebook.png"
                    />
                  </ShareNetwork>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "HomeNews",
  data() {
    return {
      posts: [],
      checked: "",
      search: "",
      response: false,
      dateSelected: new Date().toISOString().substr(0, 10)
    };
  },

  created() {
    this.getPosts();
  },

  computed: {
    filterPosts() {
      if (this.search == "") {
        return this.posts;
      } else {
        return this.posts.filter(user => {
          return (
            user.title.toLowerCase().includes(this.search.toLowerCase()) ||
            user.description.toLowerCase().includes(this.search.toLowerCase())
          );
        });
      }
    }
  },

  methods: {
    dateFormat(value) {
      const format = "LL";
      return moment(value).format(format);
    },

    getPosts() {
      window.axios.get("/api/posts").then(res => {
        this.posts = res.data;
      });
    },

    redirect(post) {
      this.$router.push({ name: "Post", params: { id: post.slug } });
    },

    redirectNews() {
      this.$router.push({ name: "News" });
    }
  }
};
</script>
